export const CHAT_SAVE = {
    SAVE_OPTION: 'CHAT_SAVE_OPTION',
    SAVE_EMAIL: 'CHAT_SAVE_EMAIL',
    SET_SUBMITTED: 'CHAT_SAVE_SET_SUBMITTED',
    RESET: 'CHAT_SAVE_RESET'
};
